import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Plus, Edit, Trash2, LogOut, Upload, Image, Calendar } from 'lucide-react';

const BACKEND_URL = 'https://api.artwithsaloni.com';
// const BACKEND_URL = /^https?:\/\//i.test(RAW_BACKEND_URL)
//   ? RAW_BACKEND_URL
//   : `https://${RAW_BACKEND_URL}`;
const API = `${BACKEND_URL}/api`;

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('artworks'); // 'artworks' or 'events'
  const [artworks, setArtworks] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    medium: '',
    dimensions: '',
    year: new Date().getFullYear().toString(),
    category: 'Folk Art',
    available: true,
    event_date: '',
    is_past: false
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const navigate = useNavigate();

  const token = localStorage.getItem('admin_token');
  // console.log(token);
  console.log(API);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      if (activeTab === 'artworks') {
        const response = await axios.get(`${API}/artworks/`);
        setArtworks(response.data || []);
      } else {
        const response = await axios.get(`${API}/events/`);
        setEvents(response.data || []);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [activeTab]);
  
  useEffect(() => {
    if (!token) {
      navigate('/admin/login');
      return;
    }
    fetchData();
  }, [activeTab, token, navigate, fetchData]);

  // const fetchData = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     if (activeTab === 'artworks') {
  //       const response = await axios.get(`${API}/artworks/`);
  //       setArtworks(response.data || []);
  //     } else {
  //       const response = await axios.get(`${API}/events/`);
  //       setEvents(response.data || []);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [activeTab]);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let itemId;
      const endpoint = activeTab === 'artworks' ? 'artworks/' : 'events/';

      if (editingItem) {
        // Update existing item
        console.log(API);
        const response = await axios.put(
          `${API}/${endpoint}/${editingItem.id}/`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        itemId = response.data.id;
      } else {
        // Create new item
        const response = await axios.post(
          `${API}/${endpoint}`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log(token);
        itemId = response.data.id;
      }

      // Upload image if selected
      if (selectedFile) {
        await uploadImage(itemId, endpoint);
      }

      fetchData();
      resetForm();
      setShowModal(false);
    } catch (error) {
      console.error('Error saving item:', error);
      alert('Error saving. Please try again.');
    }
  };

  const uploadImage = async (itemId, endpoint) => {
    setUploadingImage(true);
    const formDataImg = new FormData();
    formDataImg.append('file', selectedFile);

    try {
      await axios.post(
        `${API}/${endpoint}/${itemId}/upload-image/`,
        formDataImg,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('Error uploading image');
    } finally {
      setUploadingImage(false);
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    if (activeTab === 'artworks') {
      setFormData({
        title: item.title,
        description: item.description || '',
        medium: item.medium || '',
        dimensions: item.dimensions || '',
        year: item.year || new Date().getFullYear().toString(),
        category: item.category || 'Folk Art',
        available: item.available,
        event_date: '',
        is_past: false
      });
    } else {
      setFormData({
        title: item.title,
        description: item.description || '',
        event_date: item.event_date ? item.event_date.split('T')[0] : '',
        is_past: item.is_past || false,
        medium: '',
        dimensions: '',
        year: '',
        category: '',
        available: true
      });
    }
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm(`Are you sure you want to delete this ${activeTab === 'artworks' ? 'artwork' : 'event'}?`)) return;

    const endpoint = activeTab === 'artworks' ? 'artworks' : 'events';
    try {
      await axios.delete(`${API}/${endpoint}/${id}/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchData();
    } catch (error) {
      console.error('Error deleting:', error);
      alert('Error deleting');
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      description: '',
      medium: '',
      dimensions: '',
      year: new Date().getFullYear().toString(),
      category: 'Folk Art',
      available: true,
      event_date: '',
      is_past: false
    });
    setEditingItem(null);
    setSelectedFile(null);
  };

  if (loading) {
    return (
      <div style={{ padding: 'var(--spacing-2xl)', textAlign: 'center' }}>
        <p className="body-text">Loading...</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--color-gray-100)' }}>
      {/* Header */}
      <div style={{
        backgroundColor: 'var(--color-white)',
        padding: 'var(--spacing-lg)',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        marginBottom: 'var(--spacing-xl)'
      }}>
        <div className="container-artworld" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h1 className="section-title" style={{ margin: 0 }}>Admin Dashboard</h1>
          <button onClick={handleLogout} className="btn-inverse" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-artworld">
        {/* Tabs */}
        <div style={{ 
          display: 'flex', 
          gap: 'var(--spacing-md)', 
          marginBottom: 'var(--spacing-xl)',
          borderBottom: '2px solid var(--color-gray-200)'
        }}>
          <button
            onClick={() => setActiveTab('artworks')}
            style={{
              padding: 'var(--spacing-md) var(--spacing-lg)',
              background: 'none',
              border: 'none',
              borderBottom: activeTab === 'artworks' ? '3px solid var(--color-primary)' : 'none',
              color: activeTab === 'artworks' ? 'var(--color-primary)' : 'var(--color-gray-600)',
              fontWeight: activeTab === 'artworks' ? '600' : '400',
              cursor: 'pointer',
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <Image size={20} />
            Artworks ({artworks.length})
          </button>
          <button
            onClick={() => setActiveTab('events')}
            style={{
              padding: 'var(--spacing-md) var(--spacing-lg)',
              background: 'none',
              border: 'none',
              borderBottom: activeTab === 'events' ? '3px solid var(--color-primary)' : 'none',
              color: activeTab === 'events' ? 'var(--color-primary)' : 'var(--color-gray-600)',
              fontWeight: activeTab === 'events' ? '600' : '400',
              cursor: 'pointer',
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <Calendar size={20} />
            Events ({events.length})
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="artist-name" style={{ fontSize: '1.5rem' }}>
            {activeTab === 'artworks' ? `Manage Artworks (${artworks.length})` : `Manage Events (${events.length})`}
          </h2>
          <button
            onClick={() => {
              resetForm();
              setShowModal(true);
            }}
            className="btn-primary"
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <Plus size={18} />
            Add New {activeTab === 'artworks' ? 'Artwork' : 'Event'}
          </button>
        </div>

        {/* Grid */}
        <div className="artist-grid">
          {activeTab === 'artworks' ? (
            artworks.map((artwork) => (
            <div
              key={artwork.id}
              style={{
                backgroundColor: 'var(--color-white)',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
              }}
            >
              {artwork.image_url ? (
                <img
                  src={`${BACKEND_URL}${artwork.image_url}`}
                  alt={artwork.title}
                  style={{
                    width: '100%',
                    height: '200px',
                    objectFit: 'cover'
                  }}
                />
              ) : (
                <div style={{
                  width: '100%',
                  height: '200px',
                  backgroundColor: 'var(--color-gray-200)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--color-gray-500)'
                }}>
                  <Upload size={40} />
                </div>
              )}
              <div style={{ padding: 'var(--spacing-md)' }}>
                <h3 className="body-text" style={{ fontWeight: '600', marginBottom: '4px' }}>{artwork.title}</h3>
                <p className="caption-text" style={{ marginBottom: '8px' }}>{artwork.dimensions}</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <span className="type-indicator">{artwork.category}</span>
                  <span className="caption-text" style={{ 
                    color: artwork.available ? 'var(--color-gray-600)' : 'var(--color-gray-400)',
                    fontWeight: '600'
                  }}>
                    {artwork.available ? 'Available' : 'Sold'}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    onClick={() => handleEdit(artwork)}
                    style={{
                      flex: 1,
                      padding: '8px',
                      border: '1px solid var(--color-primary)',
                      backgroundColor: 'transparent',
                      color: 'var(--color-primary)',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '4px',
                      fontSize: '0.875rem'
                    }}
                  >
                    <Edit size={14} />
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(artwork.id)}
                    style={{
                      flex: 1,
                      padding: '8px',
                      border: '1px solid #dc3545',
                      backgroundColor: 'transparent',
                      color: '#dc3545',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '4px',
                      fontSize: '0.875rem'
                    }}
                  >
                    <Trash2 size={14} />
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))
          ) : (
            // Events Grid
            events.map((event) => (
              <div
                key={event.id}
                style={{
                  backgroundColor: 'var(--color-white)',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
                }}
              >
                {event.image_url ? (
                  <img
                    src={`${BACKEND_URL}${event.image_url}`}
                    alt={event.title}
                    style={{
                      width: '100%',
                      height: '200px',
                      objectFit: 'cover'
                    }}
                  />
                ) : (
                  <div style={{
                    width: '100%',
                    height: '200px',
                    backgroundColor: 'var(--color-gray-200)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--color-gray-500)'
                  }}>
                    <Calendar size={40} />
                  </div>
                )}
                <div style={{ padding: 'var(--spacing-md)' }}>
                  <h3 className="body-text" style={{ fontWeight: '600', marginBottom: '4px' }}>{event.title}</h3>
                  <p className="caption-text" style={{ marginBottom: '8px' }}>
                    {event.event_date ? new Date(event.event_date).toLocaleDateString() : 'Date TBA'}
                  </p>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                    <span className="type-indicator">{event.is_past ? 'Past Event' : 'Upcoming'}</span>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      onClick={() => handleEdit(event)}
                      style={{
                        flex: 1,
                        padding: '8px',
                        border: '1px solid var(--color-primary)',
                        backgroundColor: 'transparent',
                        color: 'var(--color-primary)',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '4px',
                        fontSize: '0.875rem'
                      }}
                    >
                      <Edit size={14} />
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(event.id)}
                      style={{
                        flex: 1,
                        padding: '8px',
                        border: '1px solid #dc3545',
                        backgroundColor: 'transparent',
                        color: '#dc3545',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '4px',
                        fontSize: '0.875rem'
                      }}
                    >
                      <Trash2 size={14} />
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 'var(--spacing-lg)'
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              backgroundColor: 'var(--color-white)',
              maxWidth: '600px',
              width: '100%',
              maxHeight: '90vh',
              overflow: 'auto',
              borderRadius: '8px',
              padding: 'var(--spacing-xl)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="section-title" style={{ marginBottom: 'var(--spacing-lg)', fontSize: '1.75rem' }}>
              {editingItem ? `Edit ${activeTab === 'artworks' ? 'Artwork' : 'Event'}` : `Add New ${activeTab === 'artworks' ? 'Artwork' : 'Event'}`}
            </h2>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 'var(--spacing-md)' }}>
                <label className="body-text" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Title *
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: 'var(--spacing-sm)',
                    border: '2px solid var(--color-gray-300)',
                    borderRadius: '4px',
                    fontSize: '1rem'
                  }}
                />
              </div>

              <div style={{ marginBottom: 'var(--spacing-md)' }}>
                <label className="body-text" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Description
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows="3"
                  style={{
                    width: '100%',
                    padding: 'var(--spacing-sm)',
                    border: '2px solid var(--color-gray-300)',
                    borderRadius: '4px',
                    fontSize: '1rem',
                    resize: 'vertical'
                  }}
                />
              </div>

              {activeTab === 'artworks' ? (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--spacing-md)', marginBottom: 'var(--spacing-md)' }}>
                    <div>
                      <label className="body-text" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                        Medium
                      </label>
                      <input
                        type="text"
                        name="medium"
                        value={formData.medium}
                        onChange={handleChange}
                        placeholder="e.g., Acrylic on Canvas"
                        style={{
                          width: '100%',
                          padding: 'var(--spacing-sm)',
                          border: '2px solid var(--color-gray-300)',
                          borderRadius: '4px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>

                    <div>
                      <label className="body-text" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                        Dimensions *
                      </label>
                      <input
                        type="text"
                        name="dimensions"
                        value={formData.dimensions}
                        onChange={handleChange}
                        required
                        placeholder='e.g., 16" X 18"'
                        style={{
                          width: '100%',
                          padding: 'var(--spacing-sm)',
                          border: '2px solid var(--color-gray-300)',
                          borderRadius: '4px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--spacing-md)', marginBottom: 'var(--spacing-md)' }}>
                    <div>
                      <label className="body-text" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                        Year
                      </label>
                      <input
                        type="text"
                        name="year"
                        value={formData.year}
                        onChange={handleChange}
                        style={{
                          width: '100%',
                          padding: 'var(--spacing-sm)',
                          border: '2px solid var(--color-gray-300)',
                          borderRadius: '4px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>

                    <div>
                      <label className="body-text" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                        Category *
                      </label>
                      <select
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        required
                        style={{
                          width: '100%',
                          padding: 'var(--spacing-sm)',
                          border: '2px solid var(--color-gray-300)',
                          borderRadius: '4px',
                          fontSize: '1rem'
                        }}
                      >
                        <option value="Folk Art">Folk Art</option>
                        <option value="Landscape">Landscape</option>
                        <option value="Abstract">Abstract</option>
                      </select>
                    </div>
                  </div>

                  <div style={{ marginBottom: 'var(--spacing-md)' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        name="available"
                        checked={formData.available}
                        onChange={handleChange}
                      />
                      <span className="body-text">Available for purchase</span>
                    </label>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--spacing-md)', marginBottom: 'var(--spacing-md)' }}>
                    <div>
                      <label className="body-text" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                        Event Date
                      </label>
                      <input
                        type="date"
                        name="event_date"
                        value={formData.event_date}
                        onChange={handleChange}
                        style={{
                          width: '100%',
                          padding: 'var(--spacing-sm)',
                          border: '2px solid var(--color-gray-300)',
                          borderRadius: '4px',
                          fontSize: '1rem'
                        }}
                      />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          name="is_past"
                          checked={formData.is_past}
                          onChange={handleChange}
                        />
                        <span className="body-text">Mark as past event</span>
                      </label>
                    </div>
                  </div>
                </>
              )}

              <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                <label className="body-text" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Upload Image
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  style={{
                    width: '100%',
                    padding: 'var(--spacing-sm)',
                    border: '2px solid var(--color-gray-300)',
                    borderRadius: '4px'
                  }}
                />
                {selectedFile && (
                  <p className="caption-text" style={{ marginTop: '8px' }}>
                    Selected: {selectedFile.name}
                  </p>
                )}
              </div>

              <div style={{ display: 'flex', gap: '12px' }}>
                <button type="submit" className="btn-primary" style={{ flex: 1 }} disabled={uploadingImage}>
                  {uploadingImage ? 'Uploading...' : (editingItem ? `Update ${activeTab === 'artworks' ? 'Artwork' : 'Event'}` : `Add ${activeTab === 'artworks' ? 'Artwork' : 'Event'}`)}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowModal(false);
                    resetForm();
                  }}
                  className="btn-inverse"
                  style={{ flex: 1 }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
